"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var arrowStyle = "\n\tposition: absolute;\n\tborder: solid;\n\tborder-width: 0 1px 1px 0;\n\tdisplay: inline-block;\n\tpadding: 3px;\n\tbackground-color: white;\n";
var TooltipTopArrow = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", "\n\tborder-color: ", ";\n\tbottom: 2px;\n\tleft: 50%;\n\tmargin-left: -3px;\n\ttransform: rotate(45deg);\n"], ["\n\t", "\n\tborder-color: ", ";\n\tbottom: 2px;\n\tleft: 50%;\n\tmargin-left: -3px;\n\ttransform: rotate(45deg);\n"])), arrowStyle, function (props) { return props.theme.colors.gray.main; });
var TooltipRightArrow = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", "\n\tborder-color: ", ";\n\ttop: 50%;\n\tleft: 2px;\n\tmargin-top: -3px;\n\ttransform: rotate(135deg);\n"], ["\n\t", "\n\tborder-color: ", ";\n\ttop: 50%;\n\tleft: 2px;\n\tmargin-top: -3px;\n\ttransform: rotate(135deg);\n"])), arrowStyle, function (props) { return props.theme.colors.gray.main; });
var TooltipLeftArrow = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t", "\n\tborder-color: ", ";\n\ttop: 50%;\n\tright: 2px;\n\tmargin-top: -3px;\n\ttransform: rotate(-45deg);\n"], ["\n\t", "\n\tborder-color: ", ";\n\ttop: 50%;\n\tright: 2px;\n\tmargin-top: -3px;\n\ttransform: rotate(-45deg);\n"])), arrowStyle, function (props) { return props.theme.colors.gray.main; });
var TooltipBottomArrow = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t", "\n\tborder-color: ", ";\n\ttop: 2px;\n\tleft: 50%;\n\tmargin-left: -3px;\n\ttransform: rotate(-135deg);\n"], ["\n\t", "\n\tborder-color: ", ";\n\ttop: 2px;\n\tleft: 50%;\n\tmargin-left: -3px;\n\ttransform: rotate(-135deg);\n"])), arrowStyle, function (props) { return props.theme.colors.gray.main; });
var getArrowElement = function (placement) {
    switch (placement) {
        case 'right':
            return TooltipRightArrow;
        case 'bottom':
            return TooltipBottomArrow;
        case 'left':
            return TooltipLeftArrow;
        default:
            return TooltipTopArrow;
    }
};
var TooltipArrow = function (_a) {
    var placement = _a.placement;
    var ArrowElement = React.useMemo(function () {
        return getArrowElement(placement);
    }, [placement]);
    return React.createElement(ArrowElement, null);
};
exports.default = TooltipArrow;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
